// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2wUb9","vLegacy":"SelectSecondary_vLegacy__1yYcD","error":"SelectSecondary_error__1kScP","disabled":"SelectSecondary_disabled__-fIph"};